class AutomaticScoutCondition {
  constructor() {
    this.showModal();
  }

  ready() {
    $(document).ready(function () {
      $('.automatic-scout-resume-search-form .modal').on('hidden.bs.modal', function () {
        $(this).find('.js-custom-checkbox :checkbox').prop('checked', false)
        $(this).find('.collapse').collapse('hide')
        $(this).find('.js-wrap-location').empty()
      })

      $('.skill-cer-selection .card-body').on('show.bs.collapse', function () {
        let $cardHeader = $(this).siblings('.card-header')

        $cardHeader.find('a.custom-select').css({ background: '#0A97E6' })
        $cardHeader.find('i.arrow').removeClass('down').addClass('up')
      })

      $('.skill-cer-selection .card-body').on('hidden.bs.collapse', function () {
        let $cardHeader = $(this).siblings('.card-header')

        $cardHeader.find('a.custom-select').css({ background: '#354052' })
        $cardHeader.find('i.arrow').removeClass('up').addClass('down')
      })

      $('.skill-cer-selection .js-custom-checkbox :checkbox').on('click', function () {
        let value = $(this).val()
        let isChecked = $(this).prop('checked')
        let $cardBody = $(this).closest('.card-body')
        let $cardHeader = $cardBody.siblings('.card-header')
        let $badge = $cardHeader.find('span.badge')

        let checkedLength = $cardBody.find(':checkbox:checked').length
        if (checkedLength > 0) {
          $badge.removeClass('hide')
          $badge.text(checkedLength)
        } else {
          $badge.addClass('hide')
          $badge.text('')
        }

        let cardWrappers = $cardBody.parent('.card-wrapper').siblings('.card-wrapper')
        cardWrappers.each(function () {
          let $otherCardBody = $(this).find('.card-body')
          let $otherCheckBox = $otherCardBody.find(`:checkbox[value='${value}']`)

          if ($otherCheckBox.length === 0) return

          $otherCheckBox.prop('checked', isChecked)

          let $otherCardHeader = $otherCardBody.siblings('.card-header')
          let $otherBadge = $otherCardHeader.find('span.badge')
          let otherCheckedLength = $otherCardBody.find(':checkbox:checked').length
          if (otherCheckedLength > 0) {
            $otherBadge.removeClass('hide')
            $otherBadge.text(otherCheckedLength)
          } else {
            $otherBadge.addClass('hide')
            $otherBadge.text('')
          }
        })
      })

      if (typeof gon.search_matched_candidates_path !== 'undefined') {
        const form = $('#automatic-scout-condition-form');
        const formValues = form.serialize();
        const url = gon.search_matched_candidates_path;
        form.find('.btn-calculate').addClass('disabled');
        $.ajax({
          type: 'POST',
          url: url,
          data: formValues,
        });
      }
    })
  }

  setDisableLanguageLevel(target) {
    let changedValue = $(target).val()
    let disabledTarget = $(target).parents('.js-form-other-language').find('.js-other-language-level')

    if (!changedValue) {
      disabledTarget.prop('disabled', true)
      disabledTarget.val('')
    } else {
      disabledTarget.prop('disabled', false)
    }
  }

  openModalSelect(target) {
    let $this = $(target)
    let $modal = $($this.data('modal'))
    let $wrapLocation = $modal.find('.js-wrap-location')
    let $template = $this.parent().siblings($this.data('templateContent'))
    let $groups = $this.parent().siblings($this.data('output')).find('div[id^="js-tsl"]')

    if ($groups.length) {
      $groups.each(function () {
        let $current_template = $(`<div class='js-location'>${$template.html()}</div>`)

        $wrapLocation.append($current_template)

        $(this).find('input').each(function (index) {
          let id = $(this).val()

          $($current_template.find('select').get(index)).val(id).change()
        })
      })
    } else {
      let $current_template = $(`<div class='js-location'>${$template.html()}</div>`)

      $wrapLocation.html($current_template)
    }

    if ($this.data('templateContent') == '#js-location-work-history-template') {
      this.onchange($wrapLocation.find('select').first())
    }

    $modal.modal('show')
  }

  onchange(target) {
    let $this = $(target)
    let $wrapLocation = $this.closest('.modal').find('.js-wrap-location')
    let $selects = $wrapLocation.find('select')
    let $allVals = $selects.map(function () { return $(this).val() }).get()

    $selects.each(function () {
      let select = $(this)
      let selectedVal = select.val()

      select.find('option').removeAttr('disabled')
      $allVals.forEach(function (val) {
        if (selectedVal != val && val != '') {
          select.find("option[value='" + val + "']").prop('disabled', true)
        }
      })
    })
  }

  addMoreLocation(target, idTemplate) {
    let $this = $(target)
    let $template = $(idTemplate).html()
    let $wrapLocation = $this.closest('.modal').find('.js-wrap-location')

    $wrapLocation.append(`<div class='js-location'>${$template}</div>`)
    if (idTemplate == '#js-location-work-history-template') {
      this.onchange($wrapLocation.find('select').first())
    }
  }

  onClickAgreeSelectLocation(target) {
    let $this = $(target)
    let $output = $($this.data('output'))
    let $modal = $this.parents('.modal')
    let $locations = $this.parent('.modal-footer').siblings('.modal-body').find('.js-location')
    let inputName = $this.data('inputName')
    let inputSubnames = $this.data('inputSubname').split(',')
    let alreadyLocations = []

    $output.empty()
    $locations.each(function (index) {
      let ids = []
      let text = []

      $(this).find('option:selected').each(function () {
        if (!this.value) return

        ids.push(this.value)
        text.push(this.text)
      })

      if (ids.length > 0 && !alreadyLocations.includes(ids.toString())) {
        let html = ''

        ids.forEach(function (id, index) { html += `<input type='hidden' name='${inputName}[${inputSubnames[index]}]' value=${id}>` })
        html += `<span class='badge badge-pill badge-secondary'>${text.join(' / ')}</span>`
        html = `<div id='js-tsl-${Number(new Date()) + index}' class='badge-subgroup' onclick='AutomaticScoutCondition.onClickRemoveBadgeOption(this)'>${html}</div>`
        $output.append(html)
        alreadyLocations.push(ids.toString())
      }
    })

    $modal.modal('hide')
    $modal.find('.js-wrap-location').empty()
  }

  onClickAgreeSelectCountry(target) {
    let $this = $(target)
    let $output = $($this.data('output'))
    let $modal = $this.parents('.modal')
    let $locations = $this.parent('.modal-footer').siblings('.modal-body').find('.js-location')
    let inputName = $this.data('inputName')
    let inputSubnames = $this.data('inputSubname').split(',')
    let alreadyLocations = []

    $output.empty()
    $locations.each(function (index) {
      let ids = []
      let text = []

      $(this).find('option:selected').each(function () {
        if (!this.value) return

        ids.push(this.value)
        text.push(this.text)
      })

      /*
        Select only AreaId = [AreaId]
        Select CountryId = [AreaId, CountryId]
        IF length > 0 THEN display
      */
      if (ids.length > 0 && !alreadyLocations.includes(ids.toString())) {
        let html = ''

        ids.forEach(function (id, index) { html += `<input type='hidden' name='${inputName}[${inputSubnames[index]}]' value=${id}>` })
        html += `<span class='badge badge-pill badge-secondary'>${text.join(' / ')} </span>`
        html = `<div id='js-tsl-${Number(new Date()) + index}' class='badge-subgroup' onclick='AutomaticScoutCondition.onClickRemoveBadgeOption(this)'>${html}</div>`
        $output.append(html)
        alreadyLocations.push(ids.toString())
      }
    })

    $modal.modal('hide')
    $modal.find('.js-wrap-location').empty()
  }

  updateCurrency(target, default_value = '') {
    let currency_options

    if (target.value === '') {
      currency_options = `<option value=${default_value}>----------</option>`
    } else {
      let currency_id = parseInt(target.value).toString === target.value ? parseInt(target.value) : target.value
      const currency_list = gon.currency_list[currency_id].list

      currency_options = currency_list.map(function (ele) {
        if (!ele) {
          return `<option value=''>${gon.views.shared.please_choose}</option>`
        }
        return `<option value='${ele[1]}'>${ele[0]}</option>`
      })
    }

    $(target).parents('.salary-select--dependent').find('.salary-value').html(currency_options)
  }

  openModalCheckbox(target) {
    let $this = $(target)
    let $modal = $($this.data('modal'))
    let $output = $($this.data('output'))

    $modal.find(':checkbox').prop('checked', false)
    $output.find('input[type="hidden"]').each(function () {
      let $checkBox = $modal.find(`:checkbox[value='${this.value}']`)

      $checkBox.prop('checked', true)
      $checkBox.closest('.collapse').addClass('show')

      // For job types modal
      let groupParent = $checkBox.closest('.js-group-parent')
      let unCheck = $(groupParent).find('.js-custom-checkbox :checkbox:not(:checked)')
      if (unCheck.length === 0) {
        $(groupParent).siblings().find(':checkbox').prop('checked', true)
      }
    })

    $modal.modal('show')
  }

  openSkillCerModalCheckbox(target) {
    let $this = $(target)
    let $modal = $($this.data('modal'))
    let $output = $($this.data('output'))

    $modal.find(':checkbox').prop('checked', false)
    $modal.find('.collapse').removeClass('show')
    $modal.find('span.badge').addClass('hide').text('')
    $modal.find('a.custom-select').css({ background: '#354052' })
    $modal.find('i.arrow').removeClass('up').addClass('down')

    $output.find('input[type="hidden"]').each(function () {
      let checkboxes = $modal.find(`:checkbox[value='${this.value}']`)
      checkboxes.each(function () {
        let $checkBox = $(this)
        let $cardBody = $checkBox.closest('.collapse')
        let $cardHeader = $checkBox.closest('.collapse').siblings('.card-header')
        let $badge = $cardHeader.find('span.badge')

        $checkBox.prop('checked', true)
        $checkBox.closest('.collapse').addClass('show')
        $cardHeader.find('a.custom-select').css({ background: '#0A97E6' })
        $cardHeader.find('i.arrow').removeClass('down').addClass('up')

        let checkedLength = $cardBody.find(':checkbox:checked').length
        if (checkedLength > 0) {
          $badge.removeClass('hide')
          $badge.text(checkedLength)
        } else {
          $badge.addClass('hide')
          $badge.text('')
        }
      })
    })

    $modal.modal('show')
  }

  onClickAgreeOptions(target) {
    let $this = $(target)
    let $output = $($this.data('output'))
    let $modal = $this.parents('.modal')
    let checkboxes = $this.parent('.modal-footer').siblings('.modal-body').find(':checkbox:checked')
    let input_name = $this.data('inputName')

    $output.empty()
    checkboxes.each(function (index) {
      let $itself = $(this)
      let title = $itself.data('title')
      let id = $itself.val()
      let html = ''
      if (title && id) {
        html += `<input type='hidden' name='${input_name}' value='${id}'>`
        html += `<span class='badge badge-pill badge-secondary' data-id='${id}'>${title}</span>`
        $output.append(`<div id='js-tsl-${Number(new Date()) + index}' class='badge-subgroup' onclick='AutomaticScoutCondition.onClickRemoveBadgeOption(this)'>${html}</div>`)
      }
    })

    $modal.modal('hide')
  }

  onChoseJobtype(target, type, elId) {
    if (type === 'parent') {
      if ($(target).is(':checked')) {
        $(`#group-${elId}`).find('.js-custom-checkbox :checkbox').prop('checked', true)
      } else {
        $(`#group-${elId}`).find('.js-custom-checkbox :checkbox').prop('checked', false)
      }
    } else {
      if ($(target).is(':checked')) {
        let unCheck = $(`#group-${elId}`).find('.js-custom-checkbox :checkbox:not(:checked)')
        if (unCheck.length === 0) $(`#${elId}`).prop('checked', true)
      } else {
        $(`#${elId}`).prop('checked', false)
      }
    }
  }

  onClickAgreeSkillCerOptions(target) {
    let $this = $(target)
    let $output = $($this.data('output'))
    let $modal = $this.parents('.modal')
    let checkboxes = $this.parent('.modal-footer').siblings('.modal-body').find(':checkbox:checked')
    let input_name = $this.data('inputName')

    checkboxes.each(function (index) {
      let checkboxVal = $(this).val()
      let valIsSelected = false

      $output.children().each(function () {
        if ($(this).find('span').text().toLowerCase() === checkboxVal.toLocaleLowerCase()) {
          valIsSelected = true
          return
        }
      })

      if (!valIsSelected) {
        let html = ''

        html += `<input type='hidden' name='${input_name}' value='${checkboxVal}'>`
        html += `<div class='d-flex pl-0 col-sm-11 align-items-center'><span>${checkboxVal}</span></div>`
        html += `<div class='col-sm-0 d-flex align-items-center justify-content-center'><button class='btn p-0' onclick='AutomaticScoutCondition.onClickRemoveChoseRow(this)' type='button'><i class='ct-wf ct-wf-trash'></i></button></div>`
        $output.append(`<div id='js-tsl-${Number(new Date()) + index}' class='chose-row d-flex'>${html}</div>`)
      }
    })

    $modal.modal('hide')
  }

  onClickRemoveBadgeOption(target) {
    let $this = $(target)

    $this.fadeOut(200, function () { $this.remove() })
  }

  onClickRemoveChoseRow(target) {
    let $this = $(target).closest('.chose-row')

    $this.fadeOut(200, function () { $this.remove() })
  }

  hideIconLoading() {
    $('div#page-loading').addClass('d-none')
  }

  showIconLoading() {
    $('div#page-loading').removeClass('d-none')
  }

  addInputItem(idInput, fieldName, output) {
    let $input = $(idInput)

    if (!$input.val()) return

    // 255 is validate for input type string
    if ($input.val().length > 255) {
      alert(gon.views.shared.maximum_length_255)
      return
    }

    let $output = $(output)
    let tagIsAlready = false
    $output.children().each(function () {
      if ($(this).text().toLowerCase() === $input.val().toLocaleLowerCase()) {
        tagIsAlready = true
        return
      }
    })
    if (tagIsAlready) {
      alert(gon.views.shared.search_condition_has_been_already)
    } else {
      let html = ''

      html += `<input type='hidden' name='${fieldName}' value='${$input.val()}'>`
      html += `<div class='d-flex pl-0 col-sm-11 align-items-center'><span>${$input.val()}</span></div>`
      html += `<div class='col-sm-0 d-flex align-items-center justify-content-center'><button class='btn p-0' onclick='AutomaticScoutCondition.onClickRemoveChoseRow(this)' type='button'><i class='ct-wf ct-wf-trash'></i></button></div>`
      $output.append(`<div id='js-tsl-${Number(new Date())}' class='chose-row d-flex'>${html}</div>`)
      $input.val('')
    }
  }

  showModal() {
    $(document).ready(() => {
      if ($('#automatic-scout-condition-message.modal')) {
        $('#automatic-scout-condition-message.modal').modal();
      }
    });
  }

  changeScoutCondition(element) {
    const btnSelectScoutCondition = $('#select-scout-condition');
    const resumeSearchId = element.value;
    if (resumeSearchId) {
      btnSelectScoutCondition.removeClass('disabled');
      const baseURL = location.origin + location.pathname;
      btnSelectScoutCondition.attr('href', baseURL + `?resume_search_id=${resumeSearchId}`);
    } else {
      btnSelectScoutCondition.addClass('disabled');
    }
  }

  changeCompanyUser(element) {
    const btnOpenMoldal = $('#open-modal-select-automatic-scout-condition')
    if (element.value) {
      btnOpenMoldal.removeClass('disabled pe-none')
    } else {
      btnOpenMoldal.addClass('disabled pe-none')
      event.stopPropagation()
    }
  }

  validateForm(element) {
    const form = $(element);
    let salaryValid = this.validateSalary(form.find('.group-select-salary .form-select-salary'))
    let desireSalaryValid = this.validateSalary(form.find('.group-select-desire-salary .form-select-salary'))
    let ageValid = this.validateAge(form.find('.form-select-age'))

    if (salaryValid && ageValid && desireSalaryValid) {
      form.find('input[type="submit"]').attr('disabled', false)
    } else {
      form.find('input[type="submit"]').attr('disabled', true)
    }
  }

  validateSalary(groupSalary) {
    const minSalary = parseInt(groupSalary.find('.js-min-salary').val() || 0)
    const maxSalary = parseInt(groupSalary.find('.js-max-salary').val() || 0)

    if (maxSalary == 0 || maxSalary >= minSalary) {
      this.validateRemoveClassError(groupSalary)
      return true
    } else {
      this.validateAddClassError(groupSalary)
      return false
    }
  }

  validateAge(groupAge) {
    const minAge = parseInt(groupAge.find('.js-min-age').val() || 0)
    const maxAge = parseInt(groupAge.find('.js-max-age').val() || 0)

    if (maxAge == 0 || maxAge >= minAge) {
      this.validateRemoveClassError(groupAge)
      return true
    } else {
      this.validateAddClassError(groupAge)
      return false
    }
  }

  validateAddClassError(groupElement) {
    let selectElements = groupElement.find('select')
    selectElements.addClass('error')
    selectElements.parent('div').addClass('fieldWithErrors')
  }

  validateRemoveClassError(groupElement) {
    let selectElements = groupElement.find('select')
    selectElements.removeClass('error')
    selectElements.parent('div').removeClass('fieldWithErrors')
  }

  disable_button_form(btn) {
    const form = $(btn).closest('form');
    form.find('.disabled-all').addClass('disabled');
  }

  submit_form_and_continue(btn) {
    event.preventDefault();

    const form = $(btn).closest('form');
    form.removeAttr('data-remote');
    form.find('.disabled-all').addClass('disabled');
    form.submit();
  }

  onCloseOrRedirectWindow(path) {
    if (window.history.length === 1 || (window.opener && window.opener !== window)) {
      window.opener.location.reload(true)
      window.close()
    } else {
      window.location.replace(path)
    }
  }

  getMatchedCandidatesQuantity(path) {
    event.preventDefault();

    const formValues = $('#automatic-scout-condition-form').serialize();
    const form = $('#automatic-scout-condition-form');
    form.find('.btn-calculate').addClass('disabled');

    $.ajax({
      type: 'POST',
      url: path,
      data: formValues,
    });
  }
}

export default new AutomaticScoutCondition;
